import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import HomePageStripAndServicesTab from './HomePageStripAndServicesTab';

const OtherSectionsTab = ({ settings, updateSetting }) => {
  return (
    <div className="space-y-4">
      <HomePageStripAndServicesTab settings={settings} updateSetting={updateSetting} />

      {/* App Download Section */}
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Uygulama İndirme Bölümü</CardTitle>
              <CardDescription>App Store ve Google Play linkleri</CardDescription>
            </div>
            <Switch
              checked={settings.app_section_enabled}
              onCheckedChange={(v) => updateSetting('app_section_enabled', v)}
            />
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label>Başlık</Label>
            <Input
              value={settings.app_section_title}
              onChange={(e) => updateSetting('app_section_title', e.target.value)}
              placeholder="Uygulamayı İndir"
            />
          </div>
          <div className="space-y-2">
            <Label>Alt Başlık</Label>
            <Input
              value={settings.app_section_subtitle}
              onChange={(e) => updateSetting('app_section_subtitle', e.target.value)}
              placeholder="Özel indirimler ve hızlı alışveriş için"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OtherSectionsTab;
